import { render, staticRenderFns } from "./IndicatorAddNew.vue?vue&type=template&id=65f28547"
import script from "./IndicatorAddNew.vue?vue&type=script&lang=js"
export * from "./IndicatorAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports